import React from 'react'
import moment from 'moment'
import { ScrollSyncPane } from 'react-scroll-sync'
import { NavLink } from 'react-router-dom'
import '../stylesheets/KegsIndex.sass'
import _ from 'lodash'

const KegRow = (props) => {

  return (
    <div className='keg_row'>
      { props.keg &&
        props.keg.attributes &&
      <div className='keg_row_wrapper'>
        <div className='keg_col_one'>
        </div>
        <div className='column-one keg_col created_at'>
          <div>
            { props.keg.attributes['status'] === 'checked_out' ? moment(props.keg.attributes['returnDate']).format('MM/DD/YYYY') : _.startCase(props.keg.attributes['status']) }
          </div>
        </div>
        <ScrollSyncPane>
          <div className='scroll'>
            <div className='name keg_col'>
              <div className='first_name'>
                { props.keg.attributes['uuid'] }
              </div>
            </div>
            <div className='status keg_col'>
              <div>
                { _.startCase(props.keg.attributes['status']) }
              </div>
            </div>
            <div className='street_address keg_col'>
              <div>
                { props.keg.attributes['customerName'] }
              </div>
            </div>
            <div className='street_address keg_col'>
              <div>
                { props.keg.attributes['name'] }
              </div>
            </div>
            <div className='street_address keg_col'>
              <div>
                { _.startCase(props.keg.attributes['size']) }
              </div>
            </div>
            <div className='street_address keg_col'>
              <div>
                { props.keg.attributes['style'] }
              </div>
            </div>
          </div>
        </ScrollSyncPane>
      </div>
      }
    </div>
  )
}

export default KegRow



// WEBPACK FOOTER //
// ./src/Kegs/KegRow.js